export enum LayoutType {
    BLANK = 'BLANK',
    ADMIN = 'ADMIN',
}
